import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { appRoutes } from '@/routes'
import { hydrateSession } from '@/session/hydrate'
import '@/index.css'
import '@/i18n' // must precede RouterProvider so t() is ready on first paint

// Read the learner's completions back from the Sheet so progress follows them
// across devices. Module scope, not an effect: StrictMode double-invokes those
// in dev, and this must not block first paint. `void` marks the floating
// promise intentional for nursery/noFloatingPromises — nothing awaits it, and
// hydrateSession never rejects.
void hydrateSession()

const router = createBrowserRouter(appRoutes)

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

createRoot(rootEl).render(
  <StrictMode>
    <Suspense>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
)
